import React from 'react';
import { useTranslation} from 'react-i18next';
import { motion } from 'framer-motion';
import { ASSETS_URL } from "../../constants";
import { fadeInUp, staggerContainer, staggerItem, iconVariants, hoverLift, floatingIconVariants } from '../../utility/framerMotionAnimations';

const ChooseusSection = () => {
    const {t} = useTranslation('homepage')
    return (
        <section className='why-choose-us mt-8 m-mt-5'>
            <div className="section-container">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                    variants={fadeInUp}
                >
                    <motion.div 
                        className='heading'
                        variants={fadeInUp}
                    >
                        {t('choose-us-section-heading')}
                    </motion.div>
                    <motion.div 
                        className='short-content'
                        variants={fadeInUp}
                        transition={{ delay: 0.2 }}
                    >
                        {t('choose-us-section-heading-description')}
                    </motion.div>
                </motion.div>
                <motion.div 
                    className="row mt-3 flex-row mobile-flex-block pm-40"
                    variants={staggerContainer}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                >
                    <motion.div 
                        className="col-md-4 why-box1"
                        variants={staggerItem}
                        whileHover={hoverLift.hover}
                    >
                        <div className="icon-box">
                            <motion.img 
                                src={`${ASSETS_URL}images/why-1.svg`} 
                                alt="Loan"
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                        </div>
                        <div className="icon-box-text">
                            <h3>{t('choose-us-section-box1.heading')}</h3>
                            <p>{t('choose-us-section-box1.description')}</p>
                        </div>
                    </motion.div>
                    <motion.div 
                        className="col-md-4 why-box2"
                        variants={staggerItem}
                        whileHover={hoverLift.hover}
                    >
                        <div className="icon-box">
                            <motion.img 
                                src={`${ASSETS_URL}images/why-2.svg`} 
                                alt="Loan"
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                        </div>
                        <div className="icon-box-text">
                        <h3>{t('choose-us-section-box2.heading')}</h3>
                        <p>{t('choose-us-section-box2.description')}</p>
                        </div>
                    </motion.div>
                    <motion.div 
                        className="col-md-4 why-box3"
                        variants={staggerItem}
                        whileHover={hoverLift.hover}
                    >
                        <div className="icon-box">
                            <motion.img 
                                src={`${ASSETS_URL}images/why-3.svg`} 
                                alt="Loan"
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                        </div>
                        <div className="icon-box-text">
                        <h3>{t('choose-us-section-box3.heading')}</h3>
                        <p>{t('choose-us-section-box3.description')}</p>
                        </div>
                    </motion.div>
                    <motion.div 
                        className="col-md-4 why-box4"
                        variants={staggerItem}
                        whileHover={hoverLift.hover}
                    >
                        <div className="icon-box">
                            <motion.img 
                                src={`${ASSETS_URL}images/why-4.svg`} 
                                alt="Loan"
                                variants={floatingIconVariants}
                                animate="animate"
                                style={{ background: 'transparent', backgroundColor: 'transparent' }}
                            />
                        </div>
                        <div className="icon-box-text">
                        <h3>{t('choose-us-section-box4.heading')}</h3>
                        <p>{t('choose-us-section-box4.description')}</p>
                        </div>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
}

export default ChooseusSection;